import React, { useState } from "react";
import axios from "axios";
import { isIOSApp, isAndroidApp } from "./utils/platform";
import { auth } from "./firebase";
import { logEvent } from "firebase/analytics";
import { analytics } from "./analytics";




const apiBase = process.env.REACT_APP_API_URL;

const isStoreKitAvailable = () => {
  return (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.storekit
  );
};


function Pricing() {
  const [showFounderModal, setShowFounderModal] = useState(false)
  const isiOS = isIOSApp();
const isAndroid = isAndroidApp();

const handleIOSSubscribe = () => {
  if (isStoreKitAvailable()) {
    window.webkit.messageHandlers.storekit.postMessage({
      action: "subscribe",
      productId: "com.employpilot.pro.monthly",
    });
  } else {
    alert("In-app purchases are currently unavailable.");
  }
};


const handleIOSOneTimePurchase = () => {
  if (isStoreKitAvailable()) {
    window.webkit.messageHandlers.storekit.postMessage({
      action: "purchase",
      productId: "com.employpilot.quick.resume",
    });
  } else {
    alert("In-app purchases are currently unavailable.");
  }
};



  const handleCheckout = async (plan) => {
  try {
    const user = auth.currentUser;

    if (!user) {
      alert("You must be logged in to purchase.");
      return;
    }

    console.log("📤 Sending checkout request to:", `${apiBase}/api/create-checkout-session`);

    const res = await axios.post(
  `${apiBase}/api/create-checkout-session`,
  {
    plan,
    firebase_uid: user.uid,
    email: user.email   // 🔥 REQUIRED
  }
);

    console.log("✅ Stripe session response:", res.data);

    if (res.data.url) {
      window.location.href = res.data.url;
    } else {
      alert("Checkout session could not be created.");
    }

  } catch (error) {
    console.error("❌ Stripe checkout error:", error.response?.data || error);
    alert("Error starting checkout. Please try again.");
  }
};



  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "60px 20px",
        backgroundColor: "#f0f4f8",
        minHeight: "100vh",
      }}
    >
      <h1 style={{ marginBottom: "20px", color: "#222" }}>Choose Your Plan</h1>
      <p style={{ marginBottom: "40px", color: "#555", maxWidth: "600px", textAlign: "center" }}>
        Select a plan that fits your goals. Upgrade anytime.
      </p>

      <div
        style={{
          display: "flex",
          gap: "30px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {/* QUICK RESUME - ONE TIME */}
        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "14px",
            padding: "30px",
            width: "300px",
            boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
            textAlign: "center",
            transition: "transform .2s",
          }}
        >
          <div style={{ fontSize: "14px", color: "#888", marginBottom: "10px" }}>One-Time Fee</div>

          <h2 style={{ marginBottom: "10px" }}>Quick Resume</h2>

          <p style={{ color: "#666", marginBottom: "20px" }}>
            AI-powered resume generator + full PDF download.
          </p>

          <ul style={{ textAlign: "left", paddingLeft: "20px", color: "#444", marginBottom: "20px" }}>
            <li>✔ Single AI résumé</li>
            <li>✔ PDF export + metrics</li>
            <li>✔ ATS-optimized formatting</li>
            <li>✖ No community access</li>
            <li>✖ No unlimited resumes</li>
            <li>✖ No Professional Profile builder</li>
          </ul>

          <h3 style={{ color: "#007bff", marginBottom: "15px" }}>$1.99</h3>

          <button
onClick={() => {
  const user = auth.currentUser;
  if (!user) {
    alert("You must be logged in.");
    return;
  }

  // 🔥 TRACK UPGRADE CLICK
  if (analytics) {
    logEvent(analytics, "upgrade_clicked", {
      plan: "one_time",
      location: "pricing_page"
    });
  }

  if (isiOS) {
    handleIOSOneTimePurchase();
  } else if (isAndroid) {
    window.AndroidBilling.subscribe(
      "com.employpilot.quick.resume",
      user.uid
    );
  } else {
    handleCheckout("one_time");
  }
}}
          style={{
          backgroundColor: "#007bff",
          color: "white",
          width: "100%",
          padding: "12px",
          borderRadius: "8px",
          border: "none",
          fontSize: "16px",
          cursor: "pointer",
          }}
        >
          Purchase
        </button>

        </div>

        {/* EMPLOYPILOT PRO - MONTHLY */}
        <div
          style={{
            position: "relative",
            backgroundColor: "#fff",
            borderRadius: "14px",
            padding: "30px",
            width: "300px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
            textAlign: "center",
            transform: "scale(1.03)",
          }}
        >
          {/* MOST POPULAR BADGE */}
          <div
            style={{
              position: "absolute",
              top: "-12px",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "#28a745",
              color: "white",
              padding: "5px 15px",
              borderRadius: "20px",
              fontSize: "13px",
              fontWeight: "bold",
            }}
          >
            Most Popular
          </div>

          <h2 style={{ marginBottom: "10px", marginTop: "10px" }}>EmployPilot Pro</h2>

          <p style={{ color: "#666", marginBottom: "20px" }}>
            Your complete AI career system + community access.
          </p>

          <ul style={{ textAlign: "left", paddingLeft: "20px", color: "#444", marginBottom: "20px" }}>
            <li>✔ Unlimited résumé generation</li>
            <li>✔ Premium PDF templates</li>
            <li>✔ Professional Cover Letter Generator</li>
            <li>✔ Full AI Career Coach suite</li>
            <li>✔ Resume critique & interview prep</li>
            <li>✔ Profile Builder (Social Platform-optimized) (NEW)</li>
            <li>✔ Access to Pro Community Hub</li>
            <li>✔ Pro badge + exclusive content</li>
            <li>✔ Priority support</li>
          </ul>

          <h3 style={{ color: "#28a745", marginBottom: "15px" }}>$5.99 / month</h3>

          <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
            🎉 Founding Member Launch Price<br/>
               First 50,000 users lock in this price for life.
          <span
          onClick={() => setShowFounderModal(true)}
          style={{
          display: "block",
          color: "#007bff",
          cursor: "pointer",
          marginTop: "4px",
          fontWeight: "500"
        }}
          >
            See More
       </span>
       </p>

          <button
  onClick={() => {
  const user = auth.currentUser;
  if (!user) {
    alert("You must be logged in.");
    return;
  }

  // 🔥 TRACK UPGRADE CLICK
  if (analytics) {
    logEvent(analytics, "upgrade_clicked", {
      plan: "monthly",
      location: "pricing_page"
    });
  }

  if (isiOS) {
    handleIOSSubscribe();
  } else if (isAndroid) {
    window.AndroidBilling.subscribe(
      "com.employpilot.pro.monthly",
      user.uid
    );
  } else {
    handleCheckout("monthly");
  }
}}
  style={{
    backgroundColor: "#28a745",
    color: "white",
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    fontSize: "16px",
    cursor: "pointer",
  }}
>
  Start Free Trial
</button>


          <p style={{ fontSize: "13px", marginTop: "10px", color: "#555" }}>
  7-day free trial. Full Pro access during trial.<br />
  After trial: $5.99/month.<br />
  {isiOS
    ? "Cancel anytime in Apple ID settings."
    : "Cancel anytime before trial ends."}
</p>
{isiOS && (
  <button
    onClick={() => {
      if (isStoreKitAvailable()) {
        window.webkit.messageHandlers.storekit.postMessage({
          action: "restore",
        });
      } else {
        alert("In-app purchases are currently unavailable.");
      }
    }}
    style={{
      marginTop: "12px",
      background: "transparent",
      border: "none",
      color: "#007bff",
      fontSize: "14px",
      cursor: "pointer",
    }}
  >
    Restore Purchases
  </button>
)}


    
        </div>
        {showFounderModal && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 999
    }}
  >
    <div
      style={{
        background: "#fff",
        padding: "30px",
        borderRadius: "12px",
        maxWidth: "420px",
        textAlign: "center"
      }}
    >
      <h2>Founding Member Offer</h2>

      <p style={{ color: "#555", marginTop: "10px" }}>
        To celebrate the launch of EmployPilot, the first 50,000 users who
        subscribe to the Pro plan will lock in the launch price for life.
      </p>

      <ul style={{ textAlign: "left", marginTop: "15px" }}>
        <li>✔ 7-day free trial</li>
        <li>✔ Lifetime launch pricing</li>
        <li>✔ Early access to new features</li>
      </ul>

      <p style={{ fontSize: "14px", color: "#666", marginTop: "15px" }}>
        After the founding member limit is reached, the monthly price will
        increase to reflect the full value of the platform.
      </p>

      <button
        onClick={() => setShowFounderModal(false)}
        style={{
          marginTop: "15px",
          background: "#007bff",
          color: "#fff",
          border: "none",
          padding: "10px 18px",
          borderRadius: "6px",
          cursor: "pointer"
        }}
      >
        Close
      </button>
    </div>
  </div>
)}
      </div>
    </div>
  );
}

export default Pricing;
